export default function Team({ team, side, type }) {
  return (
    <div className={`ticker-foot-card__team ticker-foot-card__team--${side}`}>
      {side === "away" && team.image && <img src={team.image} alt="logo-team-away" onError={(event) => { event.currentTarget.style.visibility = "hidden"; }} />}
      <b>{type === 'results' ? team.nameLarge : team.name}</b>
      {side === "home" && team.image && <img src={team.image} alt="logo-team-home" onError={(event) => { event.currentTarget.style.visibility = "hidden"; }} />}
    </div>
  )
}